module.exports = __webpack_public_path__ + "img/slide-2-image@3x.159da8ac.jpg";